import React from 'react'

import { Box } from '../Box/Box'
import { Inline } from '../Inline/Inline'
import { Icon } from '../Icon/Icon'
import { Text } from '../Text/Text'

type Type = 'info' | 'success' | 'caution' | 'critical'

export interface AlertProps {
  children: React.ReactNode
  type: Type
}

type ToneMap = {
  [key in Type]: 'action' | 'positive' | 'caution' | 'negative'
}

export const Alert: React.FC<AlertProps> = ({ children, type = 'info' }) => {
  const toneMap: ToneMap = {
    info: 'action',
    success: 'positive',
    caution: 'caution',
    critical: 'negative'
  }

  return (
    <Box
      border={`1px solid var(--colors-${toneMap[type]})`}
      radius="xxs"
      background={`var(--colors-${toneMap[type]}--subtle)`}
      insetStretch="s"
    >
      <Inline space="xs" alignY="center" nowrap>
        <Icon name={type} size="m" />
        <Text component="p" tone={toneMap[type]} size={['small', 'base']} weight="strong">
          {children}
        </Text>
      </Inline>
    </Box>
  )
}
